import Color from 'color';

import { DatumTypeToken } from 'dashboard/models/graph';

export enum NodeDataTypeIcon {
  Account = 'account',
  Address = 'address',
  AlertCircle = 'alert-circle',
  Api = 'api',
  Calendar = 'calendar',
  Cases = 'cases',
  CircleInfo = 'circle-info',
  Clipboard = 'clipboard',
  Clock = 'clock',
  Documentation = 'documentation',
  Edit = 'edit',
  Email = 'email',
  Events = 'events',
  FileText = 'file-text',
  Fingerprint = 'fingerprint',
  Globe = 'globe',
  Government = 'government',
  Image = 'image',
  Inquiries = 'inquiries',
  Integration = 'integration',
  Name = 'name',
  Phone = 'phone',
  Postal = 'postal',
  Similarity = 'similarity',
  Smile = 'smile',
  Shield = 'shield',
  Star = 'star',
  Team = 'team',
  Tool = 'tool',
  Transaction = 'transaction',
  Trash = 'trash',
  Unknown = 'unknown',
  Webhooks = 'webhooks',
  Workflows = 'workflows',
}

export interface CustomDatumTypeRenderConfig {
  color: Color;
  icon: NodeDataTypeIcon;
  displayName: string;
}

export enum PropertySource {
  Persona = 'persona',
  Account = 'account',
}

export interface GraphProperty {
  source: PropertySource;
  value: string;
}

export interface DatumTypeTokenToGraphProperties {
  [key: DatumTypeToken]: GraphProperty[];
}

export interface NodeRenderConfig {
  color: Color;
  icon: NodeDataTypeIcon;
  displayName: string;
  placeHolder: string;
  contextMenu: Array<GraphProperty>;
}
